var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTruckCare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fill 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.1509115,15.0947286 C13.8593228,14.8031399 13.3866467,14.8031399 13.0947779,15.0947286 C12.8031892,15.3863172 12.8031892,15.8595536 13.0947779,16.1511423 C13.3863666,16.442731 13.8596029,16.442731 14.1511916,16.1511423 C14.4427803,15.8592735 14.4427803,15.3865973 14.1509115,15.0947286 L14.1509115,15.0947286 Z M15.4740842,17.4740282 C14.702018,18.2460568 13.3508173,18.158316 12.4712988,17.2787974 L4.72289722,9.5299813 C3.47112103,9.83368203 2.09583685,9.49685236 1.11847677,8.51956766 C0.141079002,7.54228296 -0.195637601,6.16692341 0.107950068,4.91522259 L1.60858901,6.41601228 C2.07970581,6.88686526 2.84336731,6.88686526 3.31433335,6.41601228 L4.41587982,5.31420199 C4.88684587,4.8433867 4.88699663,4.07957444 4.41587982,3.60875915 L2.91505244,2.10796946 C4.16675326,1.80438179 5.54211281,2.14094764 6.51954827,3.11849616 C7.49698373,4.09578086 7.83373802,5.47114042 7.53007497,6.72284124 L15.2785519,14.4712428 C16.1580705,15.3507613 16.2461128,16.7019997 15.4740842,17.4740282 L15.4740842,17.4740282 Z M14.8645825,2.39157418 L12.3430827,3.96632108 L11.8728575,5.38312411 L9.32786399,7.92801257 L10.2745818,8.87445031 L12.8190501,6.32984195 L12.8190501,6.329982 L14.2362733,5.85947665 L15.8110202,3.33801191 L14.8645825,2.39157418 Z M7.14185928,12.5420672 L7.67601836,13.0762963 L3.85837055,16.8938041 C3.17330523,17.5790094 2.06272632,17.5790094 1.377661,16.8938041 L1.30872031,16.8248634 C0.623760029,16.1399381 0.623760029,15.0290791 1.30872031,14.3441538 L5.12636812,10.5266111 L5.6605272,11.0607001 L1.77386867,14.9472886 C1.6599362,15.0613611 1.6596561,15.246265 1.77386867,15.3606177 C1.88808123,15.4746902 2.07326525,15.4746902 2.18733776,15.3606177 L6.07385624,11.4741692 L6.72849522,12.1287382 L2.84190672,16.0151866 C2.72797426,16.1292591 2.72769415,16.3144431 2.84190672,16.4287958 C2.95611928,16.5428333 3.1413033,16.5428333 3.25523576,16.4287958 L7.14185928,12.5420672 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "detail-panel",
    transform: "translate(-209.000000, -132.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "phone-number",
    transform: "translate(209.000000, 130.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Fill-1",
    fill: "#0091EA",
    xlinkHref: "#path-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckCare);
export default __webpack_public_path__ + "static/media/truckCare.49745d2abb7546dfefc51922bb0fe805.svg";
export { ForwardRef as ReactComponent };